import { MediaQueries, ThemeProps } from '@hhgtech/hhg-components'
import styled, { css } from 'styled-components'

// import { IS_MARRY_BABY } from 'interfaces/constants'
const IS_MARRY_BABY = true

export const StyledLabelSortPin = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0px;
  cursor: pointer;

  &[data-color='gray'] {
    background: ${(props: ThemeProps) => props.theme.colors.neutral50};
  }
  &[data-color='white'] {
    border-top: 1px solid #e4e8ec;
    border-bottom: 1px solid #e4e8ec;
    background: ${(props: ThemeProps) => props.theme.colors.white};
  }

  .popover-menu__btn {
    display: flex;
    min-width: 2rem;
    height: 2rem;
    align-items: center;
    padding: 8px 0 !important;
    border: none;
    margin-left: 0.5rem;
    background: transparent;
    > span {
      display: flex;
      align-items: center;
    }

    &:hover {
      background: transparent !important;
    }
  }

  &.label-pinned {
    .label-sort-pin-icon {
      width: 16px;
      height: 16px;
      vertical-align: middle;
    }
  }

  ${IS_MARRY_BABY &&
  css`
    padding: 0.75rem 24px;
    margin: 0 -24px;

    &[data-color='white'] {
      border-bottom: none;
    }
    &[data-color='gray'] {
      background: #f3f3f3;
    }
    .popover-menu__btn {
      width: unset;
    }

    &.label-pinned {
      border-bottom: none;
      background: #fff9eb;
      border-radius: 1rem 1rem 0 0;
      .label-sort-pin-icon {
        margin-right: 8px;
      }
      .label-sort-pin-heading {
        color: #fb8c00;
      }
    }
    &.label-sorting {
      ${MediaQueries.mbUp} {
        padding-bottom: 1.5rem;
        margin-bottom: -0.75rem;
      }
    }
  `}
`
